// extracted by mini-css-extract-plugin
module.exports = {"b13nyf8m":"b13nyf8m"};